import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PART_CATALOG_CHANGES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('PART_CATALOGS');
export const PART_CATALOG_CHANGES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PART_CATALOG_CHANGES_CRUD_ACTION_CONSTANTS
);
